/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
interface Props {
  data: any;
  className: any;
  isInverted: any;
  a11yText: any;
}

const EmbeddedLink = (props: Props) => {
  const { data, className, isInverted, a11yText } = props;
  const { page, linkType } = data;
  let { title, elementId, url } = data;
  const slug = page ? page["en-NZ"].fields.slug["en-NZ"] : null;
  elementId = elementId ? elementId["en-NZ"] : null;
  title = title ? title["en-NZ"] : null;
  url = url ? url["en-NZ"] : null;
  const hasA11yText = title === "Read more" && a11yText;
  let currentClassName = className;
  if (!className) {
    if (isInverted) {
      currentClassName =
        linkType && linkType["en-NZ"] === "Button"
          ? "button button_dark"
          : "link link_strong link_strong_invert";
    } else {
      currentClassName =
        linkType && linkType["en-NZ"] === "Button"
          ? "button"
          : "link link_strong";
    }
  }

  return page ? (
    <a
      href={elementId ? `/${slug}/#${elementId}` : `/${slug}/`}
      className={currentClassName}
    >
      {title}
    </a>
  ) : (
    <a className={currentClassName} href={url}>
      {title}
      {hasA11yText && <span className="a11y">: {a11yText}</span>}
    </a>
  );
};

export default EmbeddedLink;
